export function isChildOf(obj, parentId) {
  return obj?.object?.parent?.id?.toLowerCase() === String(parentId).toLowerCase()
}
